<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { deploymentOption } from './queries/deploymentOptions.query';
import type { DeploymentOption } from './sanity/types';

useWwwSession(); // initialize www session

const route = useRoute();
const { lang } = useSiteLang();
const slices = route.path.split('/');
const langCode = slices.length > 1 ? slices[1] : null;

if (document && langCode && !isSupportedLanguageCode(langCode)) {
  document.location = replaceLanguageInPath(route.fullPath, lang.value);
}

if (document) {
  const nuxtApp = useNuxtApp();
  const locationPath = document.location.pathname;
  const payloadPath = nuxtApp.payload.path?.split('?')[0];
  if (payloadPath && locationPath !== payloadPath) {
    document.location.pathname = payloadPath;
  }
}

const { initClickTracking } = useTracking();
const { data: deploymentOptions } =
  await useWwwSanityQueryNonNull<DeploymentOption>(deploymentOption);
initClickTracking({
  waThrottle: deploymentOptions.value?.wwwAnalyticsThrottle,
});

const cspReporter = await useStaticAsset('/global-assets/csp-reporter.js', {
  tag: 'csp-reporter',
});

const fullPath = useRoute().path.replace(/\/$/, ''); // Get the full path and remove trailing slash
const nuxtApp = useNuxtApp();
const buildId = nuxtApp.$config.app.buildId;

const scripts: Array<{
  type: 'text/javascript';
  src: string;
  tagPriority: number;
  id: string;
}> = [];

if (cspReporter) {
  scripts.push({
    type: 'text/javascript',
    src: cspReporter.cdnPathname,
    tagPriority: 0,
    id: 'csp-reporter',
  });
}

useHead({
  bodyAttrs: {
    class: 'bg-white',
  },
  script: scripts,
  link: [
    {
      rel: 'preload',
      as: 'fetch',
      crossorigin: 'anonymous',
      href: `${fullPath}/_payload.json?${buildId}`,
      tagPriority: 0,
    },
  ],
});

const { otLoadHeader } = useOneTrust();
otLoadHeader({
  groupKeys: ['F'],
  headConfigs: [
    {
      hid: 'qualified-loader',
      type: 'text/javascript',
      src: 'https://js.qualified.com/qualified.js?token=MNZB19PdEuZXHF1v',
      async: true,
    },
  ],
});
</script>
